/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMeAddons } from '../fn/users/get-me-addons';
import { GetMeAddons$Params } from '../fn/users/get-me-addons';
import { LoginResponse } from '../models/login-response';
import { requestPasswordChange } from '../fn/users/request-password-change';
import { RequestPasswordChange$Params } from '../fn/users/request-password-change';

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMeAddons()` */
  static readonly GetMeAddonsPath = '/me';

  /**
   * Get information of the logged in user.
   *
   * Get user information of the logged in user.
   * It also returns the features and config of every organization the user is a member of.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeAddons()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeAddons$Response(params?: GetMeAddons$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginResponse>> {
    const obs = getMeAddons(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get information of the logged in user.
   *
   * Get user information of the logged in user.
   * It also returns the features and config of every organization the user is a member of.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeAddons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeAddons(params?: GetMeAddons$Params, context?: HttpContext): Observable<LoginResponse> {
    const resp = this.getMeAddons$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LoginResponse>): LoginResponse => r.body)
    );
  }

  /** Path part for operation `requestPasswordChange()` */
  static readonly RequestPasswordChangePath = '/users/request-password-change';

  /**
   * Request email for password change.
   *
   * Request the email for password change. Keycloak will send an email
   * to the user with a link to change the password.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestPasswordChange()` instead.
   *
   * This method doesn't expect any request body.
   */
  requestPasswordChange$Response(params?: RequestPasswordChange$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = requestPasswordChange(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Request email for password change.
   *
   * Request the email for password change. Keycloak will send an email
   * to the user with a link to change the password.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `requestPasswordChange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  requestPasswordChange(params?: RequestPasswordChange$Params, context?: HttpContext): Observable<void> {
    const resp = this.requestPasswordChange$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
